export default __webpack_public_path__ + "scene3_2_icona9ec53.png";